// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"392":"36d0354d","534":"9d375c61","848":"7ed4c8d3"}[chunkId] + ".js";
};